import React from "react"
import { Page } from "react-onsenui";
import PageHeader from "./PageHeader";
import TabBar from "./TabBar";
import { useCurrentTab, TabName } from "./TabBar/useCurrentTab";
import HistoryTabPanel from "./HistoryTabPanel";
import ScanTabPanel from "./ScanTabPanel";
import ManualEnterTabPanel from "./ManualEnterTabPanel";

const {HistoryTab, ScanTab, ManualEnterTab} = TabName

const QrPageV3 = () => {

    const {currentTab} = useCurrentTab()

    return (
        <>
            <Page style={{backgroundColor: '#F7F7F7'}}>

                <PageHeader/>

                {currentTab === HistoryTab && (
                    <HistoryTabPanel/>
                )}

                {currentTab === ScanTab && (
                    <ScanTabPanel/>
                )}

                {currentTab === ManualEnterTab && (
                    <ManualEnterTabPanel/>
                )}

                <TabBar/>

            </Page>
        </>
    )
}

export default QrPageV3
